import * as React from "react";
// import { pure } from 'recompose'
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  const { name, checked, key, onChecked, disabled, id, label } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <li key={key} className="checkBoxNormal">
      <StyledComponent.CheckBoxNormal
        type="checkbox"
        id={id}
        name={name}
        disabled={disabled}
        onChange={onChecked}
        checked={checked}
      />
      <label htmlFor={id}> {label} </label>
    </li>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  name?: any;
  checked?: any;
  onChecked?: any;
  disabled?: any;
  id?: any;
  label?: any;
  key?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/forms/input/checkbox/normal/component.tsx